import { ScrollView, View, Pressable, Linking } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "../layouts/genericPages/components/FindifyTopBarOverlay";
import { useContext, useEffect, useState } from "react";
import { FindifySimpleHeader } from "../layouts/genericPages/components/FindifySimpleHeader";
import { BasePage } from "../layouts/genericPages/helpers/BasePage";
import React from "react";
import { useTranslation } from "react-i18next";
import { MobileWorkspacesApi } from "../findifyv2-api-ts/mobile/workspaces/WorkspacesApi";
import { ContentData, MakeContentsLine } from "../layouts/genericPages/helpers/ContentSlider";
import Geolocation, { GeolocationResponse } from '@react-native-community/geolocation';
import { PlaceColors } from "../layouts/genericPages/helpers/PlaceColors";
import { PlaceText } from "@/layouts/genericPages/components/PlaceText";
import { BottomNavigationPadding } from "@/layouts/genericPages/components/FindifyNavigation";
import { processQRLinkParams } from "@/layouts/genericPages/ScanQr";
import { getTranslatedString } from "@/layouts/genericPages/helpers/FindifyTranslatedString";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { getApiFromModule } from "@/layouts/genericPages/helpers/GetContentsByModule";
const geolib = require('geolib');


const loadAvailablePlaces = async (setAvailablePlaces: any, setAvailableWorkspacesTypes: any, findifyDataContext: FindifyDataContextType) => {
  const mobileWorkspacesApi = new MobileWorkspacesApi();

  const filters = {
      published_app_eq: 1,
      status_eq: 'active'
  }
  mobileWorkspacesApi.getList(0, 100, null, filters, null).then((data) => {
      setAvailablePlaces(data.results);
      findifyDataContext.setAvailableWorkspaces(data.results);
  });

  mobileWorkspacesApi.getAvailableWorkspacesTypesList(0, 100, null, {}, null).then((data) => {
      setAvailableWorkspacesTypes(data.results);
      findifyDataContext.setAvailableWorkspacesTypes(data.results);
  })
}

export const makeDistanceString = (distanceInMeters: any) => {
    if (distanceInMeters >= 1000) {
        return (distanceInMeters / 1000).toFixed(1) + ' km';
    } else {
        return distanceInMeters + ' m';
    }
}


const makePlaceLines = (availableWorkspacesTypes: any, availablePlaces: any, setPlacesLines: any, findifyDataContext: FindifyDataContextType | null, currentUserLocation: GeolocationResponse | undefined) => {
    const pLines: any = {
        0: [] as ContentData[], // Favourite Line
        1: [] as ContentData[], // Neares Line
        // 2: [] as ContentData[], // Categories Line ( to come )
    };

    availablePlaces.map((place: any, index: number) => {
        const distanceInMeters = (currentUserLocation && place.latitude && place.longitude) ? geolib.getDistance(
            { latitude: currentUserLocation.coords.latitude, longitude: currentUserLocation.coords.longitude },
            { latitude: place.latitude, longitude: place.longitude }
        ) : undefined;
        let placeSubtitle = distanceInMeters ? makeDistanceString(distanceInMeters) : undefined;

        const address = place.address ? { [findifyDataContext?.language ?? '']: place.address } : undefined;

        if (address) {
            if (placeSubtitle) {
                placeSubtitle += ' ' + place.address
            } else {
                placeSubtitle = place.address;
            }
        }

        const clearEmptyKeys = (stringObject: any) => {
            for (const key in stringObject) {
                if ([undefined, null, ""].includes(stringObject[key])) {
                    delete stringObject[key];
                }
            }
            return stringObject;
        }
        const title = {
            ...clearEmptyKeys({ [findifyDataContext?.language ?? '']: place.name[place.languages[0]?.language?.tag] }),  // To make sure that at least has a name
            ...clearEmptyKeys((place?.name ?? {})),
            ...clearEmptyKeys((place?.app_settings?.general?.title ?? {})),
        }

        const p = {
            // image: `https://picsum.photos/64${index}/48${index}`,
            image: place.app_settings?.app_logo_url,
            workspace_id: place.workspace_id,
            name: title,
            title: title,
            subtitle: placeSubtitle ? { [findifyDataContext?.language ?? '']: placeSubtitle } : undefined,
            action: () => {
                selectWorkspace(place, findifyDataContext);
            },
            distanceFromUserInMeters: distanceInMeters,
        };

        // IF favourite
        if (findifyDataContext?.favouriteWorkspaces.includes(place.workspace_id)) {
            pLines[0].push(p);
        }
        // Push always (nearest will be sorted by distance if available)
        pLines[1].push(p);


        // Workspace types (index from 2 to available)
        const wsTypeId = place.workspace_type_id;
        // const wsTypeIndex = availableWorkspacesTypes.findIndex((wsType: any) => null === wsTypeId);
        const wsTypeIndex = availableWorkspacesTypes.findIndex((wsType: any) => wsType.workspace_type_id === wsTypeId);
        if (wsTypeIndex !== -1) {
            if (pLines[2 + wsTypeIndex]) {
                pLines[2 + wsTypeIndex].push(p);
            } else {
                pLines[2 + wsTypeIndex] = [] as ContentData[];
                pLines[2 + wsTypeIndex].push(p);
            }
        }
    });

    // sort geolocation 
    pLines[1].sort((a: any, b: any) => {
        return a.distanceFromUserInMeters - b.distanceFromUserInMeters
    });
    setPlacesLines(pLines);
}

export const selectWorkspace = (place: any, findifyDataContext: FindifyDataContextType | null) => {
    // check if current lang is available in place, if not change it to default place language
    if (!place.languages.some((l: any) => l?.language?.tag === findifyDataContext?.language)) {
        findifyDataContext?.setLanguage(place.languages[0]?.language?.tag);
    }
    if (!place?.app_settings?.enable_darkmode) {
        findifyDataContext?.setDarkMode(false);
    }
    if (!place?.app_settings?.enable_audioguide) {
        findifyDataContext?.setAudioGuide(false);
    }

    findifyDataContext?.setWorkspace(place);
    // validate token
    const authenticationApi = getApiFromModule('authentication', {
        ...findifyDataContext,
        workspace: place,
    });
    authenticationApi
        .authenticationTest()
        .then((response: any) => {
            // Keep the token saved, app infers if token is valid user is logged
        })
        .catch((error: any) => {

            findifyDataContext.setUserCustomerAccounts({
                ...findifyDataContext.userCustomerAccounts,
                [place.workspace_id]: undefined
            })
        });
    findifyDataContext?.setVisitWorkspaceSelected(true)
}

let InitialURlLoaded = false;


export const InitialPage = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const { t } = useTranslation();
    const findifyDataContext = useContext(FindifyDataContext);
    const [placesLines, setPlacesLines] = useState<any[]>([]);
    const [currentUserLocation, setCurrentUserLocation] = useState<GeolocationResponse | undefined>();
    const [availablePlaces, setAvailablePlaces] = useState<any[]>([]);
    const [availableWorkspacesTypes, setAvailableWorkspacesTypes] = useState<any[]>([]);
    const [topWorkspace, setTopWorkspace] = useState<any>(null);

    useEffect(() => {
        Linking.addEventListener('url', ({ url }) => {
            if (url) {
                processQRLinkParams(url.split('?')[1], findifyDataContext, navigation, () => { }, () => { })
            }
        });

        if (!InitialURlLoaded) {
            InitialURlLoaded = true;
            Linking.getInitialURL().then((url) => {
                if (url) {
                    processQRLinkParams(url.split('?')[1], findifyDataContext, navigation, () => { }, () => { })
                }
            })
        }
    }, [])

    useEffect(() => {
        setTopWorkspace(findifyDataContext?.workspace);
        Geolocation.getCurrentPosition(info => setCurrentUserLocation(info));
        loadAvailablePlaces(setAvailablePlaces, setAvailableWorkspacesTypes, findifyDataContext);
    }, [])

    useEffect(() => {
        makePlaceLines(availableWorkspacesTypes, availablePlaces, setPlacesLines, findifyDataContext, currentUserLocation);
    }, [currentUserLocation, availableWorkspacesTypes, availablePlaces])

    useEffect(() => {
        if (!topWorkspace) {
            if (placesLines[1] && placesLines[1].length > 0) {
                setTopWorkspace(availablePlaces.find((p: any) => p.workspace_id === placesLines[1][0].workspace_id));
            }
        }
    }, [placesLines])


    return <BasePage hideBottomNavigation={false} navigation={navigation}>
        <FindifyTopBarOverlay />
        <ScrollView bounces={false}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            style={{ paddingBottom: insets.bottom + BottomNavigationPadding, backgroundColor: PlaceColors(findifyDataContext).background.get() }}>
            <View style={{
                paddingBottom: insets.bottom + BottomNavigationPadding
            }}>
                {topWorkspace &&
                    <View style={{ margin: 15, borderRadius: 24, overflow: 'hidden', shadowColor: '#000', shadowOpacity: 0.15, shadowRadius: 10, shadowOffset: { width: 0, height: 5 }, elevation: 6, backgroundColor: 'white' }}>
                        <Pressable onPress={() => {
                            selectWorkspace(topWorkspace, findifyDataContext);
                        }}>
                            <FindifySimpleHeader
                                title={getTranslatedString(topWorkspace?.title, findifyDataContext)}
                                navigation={null}
                                image={topWorkspace?.app_settings?.app_logo_url}
                            >
                                <View style={{
                                    position: 'absolute',
                                    top: 15,
                                    right: 15,
                                    paddingHorizontal: 12,
                                    paddingVertical: 6,
                                    borderRadius: 12,
                                    backgroundColor: PlaceColors(findifyDataContext).findifyPrimary.get(),
                                    shadowColor: '#000', shadowOpacity: 0.3, shadowRadius: 3, shadowOffset: { width: 0, height: 2 }, elevation: 4,
                                }}>
                                    <PlaceText style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }} >
                                        {findifyDataContext?.workspace ? t('initial_page.last_visited') : t('initial_page.near_you')}
                                    </PlaceText>
                                </View>
                            </FindifySimpleHeader>
                        </Pressable>
                    </View>
                }
                {/* Favourite */}
                {placesLines[0] && placesLines[0].length > 0 &&
                    <MakeContentsLine
                        key={"contents_line_favourites"}
                        language={findifyDataContext?.language ?? ''}
                        title={t('initial_page.favourites')}
                        module={'contents'} // It's used to get the workspace title only

                        titleColor={PlaceColors(findifyDataContext).findifyPrimary.get()}
                        seeMoreColor={PlaceColors(findifyDataContext).findifySecondary.get()}
                        lIndex={0}
                        rounded={true}
                        contents={placesLines[0]}
                        viewAllAction={() => {
                            navigation.push('IntialPagePlaceList', { favourite_list: true })
                        }}
                    />
                }
                {/* NEAR */}
                {placesLines[1] && placesLines[1].length > 0 &&
                    <MakeContentsLine
                        key={"contents_line_near_you"}
                        language={findifyDataContext?.language ?? ''}
                        title={t('initial_page.near_you')}
                        lIndex={1}
                        module={'contents'} // It's used to get the workspace title only
                        titleColor={PlaceColors(findifyDataContext).findifyPrimary.get()}
                        seeMoreColor={PlaceColors(findifyDataContext).findifySecondary.get()}
                        contents={placesLines[1]}
                        viewAllAction={() => {
                            navigation.push('IntialPagePlaceList', { near_list: true });
                        }}
                    />
                }
                {/* Workspaces Types */}
                {Object.keys(placesLines).map((key, index) => {
                    if (+key > 1) {
                        const type = availableWorkspacesTypes[+key - 2];
                        return <MakeContentsLine
                            key={"contents_line_ws_type_" + type.workspace_type_id}
                            language={findifyDataContext?.language ?? ''}
                            title={getTranslatedString(type.name, findifyDataContext)}
                            lIndex={index + 2}
                            module={'contents'} // It's used to get the workspace title only
                            titleColor={PlaceColors(findifyDataContext).findifyPrimary.get()}
                            seeMoreColor={PlaceColors(findifyDataContext).findifySecondary.get()}
                            contents={placesLines[+key]}
                            viewAllAction={() => {
                                navigation.push('IntialPagePlaceList', { workspace_type_id: type.workspace_type_id });
                            }}
                        />
                    }
                })}
            </View>
        </ScrollView>
    </BasePage>;
};
